
import { defineComponent, ref, computed, watch, onBeforeMount, onBeforeUnmount, PropType } from 'vue'
import { formatDistanceToNow } from 'date-fns'
import { copyToClipboard } from '@/util'
import { SnackbarMessage } from '@/types/snackbar'
import { useStore } from '@/composables/use-store'

export default defineComponent({
  name: 'TimeDeltaHuman',
  props: {
    date: {
      type: [Date, String] as PropType<Date | string>,
      required: true
    },
    updateSeconds: {
      type: Number,
      default: 30
    }
  },
  setup (props) {
    const store = useStore()
    const updateInterval = ref<number | undefined>(undefined)
    const distance = ref<string>('')

    const dateObj = computed<Date>(() => {
      if (typeof props.date === 'string') {
        return new Date(props.date)
      }
      return props.date
    })

    const makeDelta = (): string => {
      return formatDistanceToNow(dateObj.value, { addSuffix: true, includeSeconds: true })
    }

    const showMessage = (message: SnackbarMessage) => {
      store.dispatch('snackbar/SHOW_MESSAGE', message)
    }

    const copyIsoDate = () => {
      const isoDate = dateObj.value.toISOString()
      copyToClipboard(isoDate)
      showMessage({ content: 'Timestamp copied to clipboard', timeout: 2000 })
    }

    onBeforeMount(() => {
      distance.value = makeDelta()
      updateInterval.value = window.setInterval(() => {
        distance.value = makeDelta()
      }, props.updateSeconds * 1000 + Math.ceil(Math.random() * 1000))
    })

    watch(
      () => props.date,
      () => {
        distance.value = makeDelta()
      }
    )

    onBeforeUnmount(() => {
      if (updateInterval.value !== undefined) {
        window.clearInterval(updateInterval.value)
      }
    })

    return {
      dateObj,
      distance,
      copyIsoDate
    }
  }
})
